import React, { useState, useEffect } from 'react'
// import logo from '../assets/images/logo.svg'
import axios from 'axios'
import { BASE_URL } from './BaseUrl'
import md5 from 'js-md5'
import { useNavigate } from 'react-router-dom'
import Cookies from 'js-cookie';
import logo from '../assets/frontimg/logo.jpg'
import CryptoJS from 'crypto-js';

const WebLogin = () => {
  const [value, setValue] = useState({
    email: "",
    password: "",
    role: ""
  })

  const [err, setErr] = useState("")
  const [roles, setRoles] = useState([]);

    async function getRole() {
        axios.get(`${BASE_URL}/role_data`)
            .then((res) => {
                setRoles(res.data)
            })
            .catch((err) => {
                console.log(err)
            })
    }

    useEffect(() => {
        getRole()
    }, [])

  const navigate = useNavigate()

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    let errors = {};
    let isValid = true;

    if (!value.email) {
      errors.email = 'Email is required';
      isValid = false;
    }

    if (!value.password) {
      errors.password = 'Password is required';
      isValid = false;
    }

    if (!value.role || value.role === 'Select Role') {
      errors.role = 'Role is required';
      isValid = false;
    }

    setErrors(errors);

    return isValid;
  };


  const encryptionKey = 'sitsuvidya';

  const handleSubmit = (e) => {
    e.preventDefault()

    if (validateForm()) {

      const hashpass = md5(value.password)

      const data = {
        email: value.email,
        password: hashpass,
        role: value.role
      }

      axios.post(`${BASE_URL}/login`, data)
        .then((res) => {
          console.log(res.data.err)
          if (res.data.id) {
            const role = res.data.data[0].role
            const token = res.data.token
            const ciphertext = CryptoJS.AES.encrypt(res.data.id.toString(), encryptionKey).toString();
            Cookies.set('userid', ciphertext, { expires: 1 });
            Cookies.set('role', role, { expires: 1 });
            Cookies.set('token', token, { expires: 1 });
            navigate('/')
          }
          else {
            setErr(res.data)
          }

        })
        .catch((err) => {
          console.log(err)
        })
    }
  }

  const onhandleChange = (e) => {
    setValue((prev) => ({ ...prev, [e.target.name]: e.target.value }))
  }



  return (
    <div className="container-scroller d-flex">
      <div className="container-fluid page-body-wrapper full-page-wrapper d-flex">
        <div className="content-wrapper d-flex align-items-center auth px-0">
          <div className="row w-100 mx-0">
            <div className="col-lg-4 mx-auto">
              <div className="auth-form-light text-left py-5 px-4 px-sm-5">
                <div className="brand-logo mb-3">
                  {/* <img src={logo} alt="logo" /> */}
                  <h3 className="font-weight-bold text-primary" style={{ fontWeight: 700 }}>
                    Apachi Institute Management
                  </h3>
                </div>
                <h4>Hello! let's get started</h4>
                <h6 className="font-weight-light">Sign in to continue.</h6>
                <form className="pt-3" method="POST" onSubmit={handleSubmit}>
                  <div className="form-group">
                    <input
                      type="email"
                      className={`form-control form-control-lg ${errors.email ? 'is-invalid' : ''}`}
                      id="exampleInputEmail1"
                      placeholder="Username"
                      name="email"
                      onChange={onhandleChange}
                    />
                    {errors.email && (
                      <div className="invalid-feedback">{errors.email}</div>
                    )}
                  </div>
                  <div className="form-group">
                    <input
                      type="password"
                      className={`form-control form-control-lg ${errors.password ? 'is-invalid' : ''}`}
                      id="exampleInputPassword1"
                      placeholder="Password"
                      name="password"
                      onChange={onhandleChange}
                    />
                    {errors.password && (
                      <div className="invalid-feedback">{errors.password}</div>
                    )}
                  </div>
                  <select
                    className={`form-control form-control-sm ${errors.role ? 'is-invalid' : ''}`}
                    name="role"
                    onChange={onhandleChange}
                  >
                    <option value="">Select Role</option>

                    {roles.map((role) => (
                      <option key={role.id} value={role.id}>
                        {role.title}
                      </option>

                    ))}
                  </select>

                  {errors.role && (
                    <div className="invalid-feedback">{errors.role}</div>
                  )}


                  <div className="mt-3">
                    <button
                      className="btn btn-block btn-primary btn-sm font-weight-medium auth-form-btn"
                      type="submit"
                    >
                      SIGN IN
                    </button>
                  </div>
                  <p className='text-danger'>{err}</p>
                </form>



              </div>
            </div>
          </div>
        </div>

      </div>

    </div>
  )
}

export default WebLogin;

